/**
 * Extract file key and optional node ID from a Figma URL.
 *
 * Supported URL formats:
 * - https://www.figma.com/file/ABC123/FileName
 * - https://www.figma.com/design/ABC123/FileName
 * - https://www.figma.com/file/ABC123/FileName?node-id=1-2
 * - https://www.figma.com/design/ABC123/FileName?node-id=1%3A2
 */
export function parseFigmaUrl(url: string): { fileKey: string; nodeId?: string } | null {
  try {
    const parsed = new URL(url);
    if (!parsed.hostname.includes('figma.com')) {
      return null;
    }

    const pathMatch = parsed.pathname.match(/\/(file|design)\/([a-zA-Z0-9]+)/);
    if (!pathMatch) {
      return null;
    }

    const fileKey = pathMatch[2];
    const nodeId = parsed.searchParams.get('node-id') || undefined;

    return { fileKey, nodeId };
  } catch {
    return null;
  }
}
